<template>
  <div class="input-wrapper">
    <span class="input-error-box" v-show="errors.has(name)">{{ errors.first(name) ? errors.first(name).replace('_', ' ') : errors.first(name) }}</span>
    <label v-if="label" :for="id">{{label}}</label>
     <input
      :id="id"
      :type="type"
      :value="value"
      :name="name"
      :placeholder="placeholder" @input="$emit('input',$event.target.value)"
      :class="classes"
      v-validate="required"
    />
  </div>
</template>

<script>

export default {
  name: 'Input',
  data: () => ({
  }),
  components: {
  },
  computed: {
  },
  props: {
    id: { type: String , required: false, default: null },
    type: { type: String , required: false, default: null },
    value: { type: String , required: false, default: null },
    label: { type: String , required: false, default: null },
    name: { type: String , required: false, default: null },
    placeholder: { type: String, required: false, default: null },
    classes: { type: String, required: false, default: null },
    required: { type: String, required: false, default: null }
  },
  mounted () {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../scss/global/includes";

.input-wrapper {
    width: 100%;
    max-width: 100%;
    display: block;
    position: relative;
    margin-bottom: 20px;
}

.input-wrapper label {
    color: $strong-light;
    font-size: 14px;
    padding-bottom: 5px;
    display: block;
}

.input-wrapper input {
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    box-shadow: none !important;
    outline: none;
    font-size: 15px;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 1px solid #9B9B9B;
    color: #9B9B9B;
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 10px 15px;
    display: block;
    width: 100%;
    outline: none;
    background: #FFFFFF;
    height: auto;


    @include placeholder {
      color: $placeholder;
    }
}

</style>
